import { getSimplrAccountIdOfSelectedTicket } from 'extractFromState';
import { clearOrders, setOrders } from 'actions/tools/OrdersSearchActions';
import { revolveGetQuery } from 'api/orders/revolve';
import { setLoading } from 'actions';
import { showErrorMessage } from 'util/errorPopupUtil';
import { handleError } from 'services/ErrorService/ErrorService';

export const revolveFindOrders = (searchType, searchValue) => async (dispatch, getState) => {
  const state = getState();
  const simplrAccountId = getSimplrAccountIdOfSelectedTicket(state);

  const params = {
    simplrAccountId,
    searchType,
    searchValue,
  };

  try {
    dispatch(clearOrders());
    const responseBody = await revolveGetQuery('/searchOrders', params);
    dispatch(setLoading(false, 'searchPage'));
    dispatch(setOrders(responseBody));
  } catch (err) {
    dispatch(setLoading(false, 'searchPage'));
    handleError({ error: err, customMessage: 'Error getting Revolve orders' });
    if (err.status === 404) {
      return dispatch(setOrders([]));
    }
    if (err.status >= 500) {
      return showErrorMessage('Find orders failed');
    }
    let errorMessage = err.text;
    if (!errorMessage) {
      errorMessage = err.response && err.response.text ? err.response.text : 'Request failed';
    }
    showErrorMessage(errorMessage);
  }
};
